import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "question"
}
const _hoisted_2 = { class: "prompt" }
const _hoisted_3 = { class: "radio-selectors column" }
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "progress row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-circle-left" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-step-backward" }, null, -1)
const _hoisted_8 = { class: "question-num" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mini-label" }, "Question", -1)
const _hoisted_10 = { class: "num-value" }
const _hoisted_11 = { class: "completed" }
const _hoisted_12 = { class: "num-value" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mini-label" }, "answered", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-step-forward" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-circle-right" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "submit-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Slider = _resolveComponent("Slider")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["survey-container widget-pane", _ctx.wrapperClasses])
  }, [
    (_ctx.hasQuestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.prompt), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (opt) => {
              return (_openBlock(), _createElementBlock("div", {
                key: opt.key,
                class: "p-field-radiobutton option row"
              }, [
                _createVNode(_component_RadioButton, {
                  id: opt.itemKey('id'),
                  name: "value",
                  value: opt.value,
                  modelValue: _ctx.currValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currValue) = $event))
                }, null, 8, ["id", "value", "modelValue"]),
                _createElementVNode("label", {
                  for: opt.itemKey('id')
                }, _toDisplayString(opt.title), 9, _hoisted_4)
              ]))
            }), 128))
          ]),
          _createElementVNode("i", {
            class: "pi pi-arrow-circle-right primary-trigger right-half",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
          }),
          _createElementVNode("nav", _hoisted_5, [
            _createVNode(_component_Button, {
              onClick: _ctx.prev,
              class: "large-icon p-button-text anchored left-end"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.hasUnanswered)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: _ctx.stepBack,
                  class: "p-button-text anchored inner-bt left-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _ctx.prevUnsweredTooltip,
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("em", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.questionNum), 1)
            ]),
            _createVNode(_component_Slider, {
              modelValue: _ctx.index,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.index) = $event)),
              range: false,
              min: 0,
              max: _ctx.lastIndex,
              class: "nav-slider"
            }, null, 8, ["modelValue", "max"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.numAnswersValue), 1),
              _hoisted_13
            ]),
            (_ctx.hasUnanswered)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  onClick: _ctx.stepForward,
                  class: "p-button-text anchored inner-bt right-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _ctx.nextUnsweredTooltip,
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              onClick: _ctx.next,
              class: "large-icon p-button-text anchored right-end",
              text: true
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          (_ctx.showSubmit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_Button, { onClick: _ctx.submitAnswers }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.submitLabel), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}